export const mrmsState = {
  rasterMetaData: null,
};
